export default [
  { 'id': 1, 'metodo_pago': 'mercadopago', 'cuotas': 1, 'porcentaje': 8.0 },
  { 'id': 2, 'metodo_pago': 'mercadopago', 'cuotas': 3, 'porcentaje': 8.0 },
  { 'id': 3, 'metodo_pago': 'mercadopago', 'cuotas': 6, 'porcentaje': 8.0 },
  { 'id': 4, 'metodo_pago': 'mercadopago', 'cuotas': 12, 'porcentaje': 8.0 },
  { 'id': 5, 'metodo_pago': 'todopago', 'cuotas': 1, 'porcentaje': 9.0 },
  { 'id': 6, 'metodo_pago': 'todopago', 'cuotas': 2, 'porcentaje': 13.0 },
  { 'id': 7, 'metodo_pago': 'todopago', 'cuotas': 3, 'porcentaje': 13.0 },
  { 'id': 8, 'metodo_pago': 'todopago', 'cuotas': 4, 'porcentaje': 13.0 },
  { 'id': 9, 'metodo_pago': 'todopago', 'cuotas': 5, 'porcentaje': 13.0 },
  { 'id': 10, 'metodo_pago': 'todopago', 'cuotas': 6, 'porcentaje': 15.0 },
  { 'id': 11, 'metodo_pago': 'todopago', 'cuotas': 7, 'porcentaje': 18.0 },
  { 'id': 12, 'metodo_pago': 'todopago', 'cuotas': 8, 'porcentaje': 18.0 },
  { 'id': 13, 'metodo_pago': 'todopago', 'cuotas': 9, 'porcentaje': 18.0 },
  { 'id': 14, 'metodo_pago': 'todopago', 'cuotas': 10, 'porcentaje': 18.0 },
  { 'id': 15, 'metodo_pago': 'todopago', 'cuotas': 11, 'porcentaje': 18.0 },
  { 'id': 16, 'metodo_pago': 'todopago', 'cuotas': 12, 'porcentaje': 20.0 },
];

